import { render, staticRenderFns } from "./SendInvoiceReminderEmailModal.vue?vue&type=template&id=2000c8b2&"
import script from "./SendInvoiceReminderEmailModal.vue?vue&type=script&lang=js&"
export * from "./SendInvoiceReminderEmailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SendInvoiceReminderEmailModal.vue"
export default component.exports